import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive, toRefs } from "vue";
import MyHandling from "./my-handling/index.vue";
import MyInfo from "./my-info/index.vue";
import MyLicense from "./my-license/index.vue";
import MyPost from "./my-post/index.vue";
import MyConsult from "./my-consult/index.vue";
import MyComplain from "./my-complain/index.vue";
import MyReport from "./my-report/index.vue";
import MyCloudExploration from "./cloud-exploration/index.vue";
import PublishContentConfig from "./publishContentConfig/index.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    val: String
},
  setup(__props) {

const props = __props
const data = reactive({
    itemList:[],
})
const { val } = toRefs(props) as any
console.log('val::',val.value);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(val) === '1')
      ? (_openBlock(), _createBlock(MyHandling, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(val) === '2')
      ? (_openBlock(), _createBlock(MyInfo, { key: 1 }))
      : _createCommentVNode("", true),
    (_unref(val) === '3')
      ? (_openBlock(), _createBlock(MyLicense, { key: 2 }))
      : _createCommentVNode("", true),
    (_unref(val) === '4')
      ? (_openBlock(), _createBlock(MyPost, { key: 3 }))
      : _createCommentVNode("", true),
    (_unref(val) === '5')
      ? (_openBlock(), _createBlock(MyConsult, { key: 4 }))
      : _createCommentVNode("", true),
    (_unref(val) === '6')
      ? (_openBlock(), _createBlock(MyComplain, { key: 5 }))
      : _createCommentVNode("", true),
    (_unref(val) === '7')
      ? (_openBlock(), _createBlock(MyReport, { key: 6 }))
      : _createCommentVNode("", true),
    (_unref(val) === '8')
      ? (_openBlock(), _createBlock(MyCloudExploration, { key: 7 }))
      : _createCommentVNode("", true),
    (_unref(val) === '9')
      ? (_openBlock(), _createBlock(PublishContentConfig, { key: 8 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})